import React, { Component } from 'react'

//props tabs array format
// [{
//     name: "example",
//     component: <Component />
// }]
class Tabs extends Component {

    state = {
        tab: 0
    };
        
    changeTab(tab){
        this.setState({tab})
    }

    render() {
        return(
            <div>
                <ul className="nav nav-tabs">
                    {
                        this.props.tabs.map((tab, index) => 
                            <li 
                                className={`${this.state.tab === index ? 'active' : ''}`.trim()}
                                key={`tab-${index}-${tab.name}`}
                            >
                                {/* eslint-disable-next-line */}
                                <a onClick={() => this.changeTab(index)}>
                                    {tab.name}
                                </a>
                            </li>
                        )
                    }
                </ul>
                <div className="tab-content">
                    {
                        this.props.tabs.map((tab, index) => 
                            <div 
                                className={`tab-pane ${this.state.tab === index ? 'fade active in' : ''}`.trim()}
                                key={`tabcomponent-${index}-${tab.name}`}
                            >
                                {tab.component}   
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}


export default Tabs
